import {
  deleteClientCookie,
  getClientCookie,
  setClientCookie,
} from 'Shared/utils/client/clientCookie';
import { deleteServerCookie, getServerCookie, setServerCookie } from 'Shared/utils/serverCookie';
import type { TokenRepository } from 'viewup-lib/common';

export class TokenRepositoryImpl implements TokenRepository<true> {
  static TOKEN_KEY = 'token';

  async getToken(): Promise<string> {
    // const token = getLocalStorageItem<string>(TokenRepositoryImpl.TOKEN_KEY) || '';
    if (typeof window === 'undefined') {
      return (await getServerCookie(TokenRepositoryImpl.TOKEN_KEY)) || '';
    }
    return getClientCookie(TokenRepositoryImpl.TOKEN_KEY) || '';
  }

  async saveToken(token: string): Promise<void> {
    if (typeof window === 'undefined') {
      await setServerCookie(TokenRepositoryImpl.TOKEN_KEY, token, {
        expires: Date.now() + 15 * 24 * 60 * 60 * 1000,
      });
      return;
    }

    setClientCookie(TokenRepositoryImpl.TOKEN_KEY, token, 15);
  }

  async removeToken(): Promise<void> {
    if (typeof window === 'undefined') {
      await deleteServerCookie(TokenRepositoryImpl.TOKEN_KEY);
      return;
    }

    deleteClientCookie(TokenRepositoryImpl.TOKEN_KEY);
  }
}
